import { apiCall } from '@/lib/api-client';

export interface NotificationDto {
  id: string;
  type: string;
  payload: Record<string, unknown> | null;
  readAt: string | null;
  createdAt: string;
}

export interface NotificationResponse {
  data: NotificationDto[];
}

export const notificationsApi = {
  getNotifications: (limit: number = 10, unreadOnly: boolean = false) =>
    apiCall<NotificationDto[]>(`/notifications/me?limit=${limit}&unreadOnly=${unreadOnly}`),

  getUnreadCount: () =>
    apiCall<{ count: number }>('/notifications/unread-count'),

  markAsRead: (id: string) =>
    apiCall<{ ok: true }>(`/notifications/${id}/read`, {
      method: 'PATCH',
    }),

  markAllAsRead: () =>
    apiCall<{ ok: true }>('/notifications/read-all', {
      method: 'POST',
    }),
};
